
export default {
    state: {
        burningId: null,
        division_id: null,
        orderListTab: '',
        rejectedId: null,
        orderNumber: '',
    }
}